import { request } from '@wix/da-shared-react/pkg/xhr';
import { SagaIterator } from 'redux-saga';
import { API_BASE_PATH } from '../../constants';
import { select, call, put, takeLatest } from 'redux-saga/effects';
import { donatePoints } from '../actions/donations';
import { updateModule } from '../actions/modules';
import { runModuleInitActions } from '../sagas/modules';
import { getProfileOwnerUser } from '../selectors/users';
import { getModuleVersion, getModuleMeta } from '../selectors/modules';

function* post(endpoint, data) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/donations/${endpoint}`,
    data,
  });
}

export function* donatePointsSaga(
  action: ReturnType<typeof donatePoints>
): SagaIterator {
  const { moduleId, amount, message, isPrivate } = action?.payload || {};
  const version = yield select(getModuleVersion, moduleId);
  const { isDonating } = yield select(getModuleMeta, moduleId);
  if (isDonating) {
    return;
  }
  yield put(
    updateModule({
      id: moduleId,
      moduleMeta: {
        isDonating: true,
        isDonationSuccess: false,
        donationErrorMessage: '',
      },
    })
  );
  const { username } = yield select(getProfileOwnerUser);

  const response = yield call(post, 'give', {
    amount,
    message,
    moduleid: moduleId,
    is_private: isPrivate,
    version,
    username,
  });

  if (response?.moduleData) {
    yield call(runModuleInitActions, response);
    yield put(
      updateModule({
        id: moduleId,
        moduleMeta: {
          isDonating: false,
          isDonationSuccess: true,
          donationErrorMessage: '',
        },
      })
    );
  } else {
    const donationErrorMessage =
      (response?.errorCode && response?.message) ||
      'widgets.donations.error.unexpectedErrorOccurred';
    yield put(
      updateModule({
        id: moduleId,
        moduleMeta: {
          isDonating: false,
          isDonationSuccess: false,
          donationErrorMessage,
        },
      })
    );
  }
}

export default [takeLatest(donatePoints, donatePointsSaga)];
